export default __webpack_public_path__ + "static/media/img_12.4d2e777e.jpg";